// extracted by mini-css-extract-plugin
export default {"Container":"Federal_Container__hUl1F","section-1":"Federal_section-1__FcaZQ","content":"Federal_content__p-snH","section-2":"Federal_section-2__+xATu"};